import { useLocale } from "./localization";
import { formatMinorAmount } from "./minor-unit-format";
import "./RiyalAmount.css";

/** Official SAMA artwork, rendered as a current-color mask without font support. */
export function RiyalSymbol({
  className = "",
}: {
  readonly className?: string;
}) {
  const { locale } = useLocale();
  return (
    <span
      className={`riyal-symbol ${className}`.trim()}
      role="img"
      aria-label={locale === "ar-SA" ? "ريال سعودي" : "Saudi riyal"}
    />
  );
}

export function RiyalAmount({
  minor,
  currency = "SAR",
  fractionDigits,
}: {
  readonly minor: number | null;
  readonly currency?: string;
  readonly fractionDigits?: number;
}) {
  const { locale, t } = useLocale();
  const formatted = formatMinorAmount(minor, locale, currency, fractionDigits);
  if (formatted === null) return <span>{t("common.unavailable")}</span>;
  if (currency !== "SAR") {
    return (
      <bdi className="riyal-amount" dir="ltr">
        {formatted}
      </bdi>
    );
  }
  return (
    <bdi className="riyal-amount" dir="ltr">
      <RiyalSymbol />
      <span>{formatted}</span>
    </bdi>
  );
}
